module.exports = __webpack_public_path__ + "static/media/message.51fb9040.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/message.png
// module id = 7472
// module chunks = 0